import axios, { AxiosRequestConfig } from "axios";
import { CashManagementProviderCustomerConfig } from "../models/CashManagementProviderCustomerConfig";
import { UUID } from "../utils";
import getErrorDetails from "./helpers/getErrorDetails";
import { PaginatedList } from "./helpers/pagination";

export type PostCashManagementProviderCustomerConfig = (
  /**
   * @description Customer ID
   */
  id: UUID,
  data: CashManagementProviderCustomerConfig,
  options?: AxiosRequestConfig
) => Promise<CashManagementProviderCustomerConfig>;

export type PutCashManagementProviderCustomerConfig = (
  /**
   * @description ProviderCustomerConfig ID
   */
  id: UUID,
  data: CashManagementProviderCustomerConfig,
  options?: AxiosRequestConfig
) => Promise<CashManagementProviderCustomerConfig>;

export type GetCashManagementProviderCustomerConfig = (
  /**
   * @description ProviderCustomerConfig ID
   */
  id: UUID,
  options?: AxiosRequestConfig
) => Promise<CashManagementProviderCustomerConfig>;

export type GetCashManagementProviderCustomerConfigs = (
  /**
   * @description Customer ID
   */
  id: UUID,
  options?: AxiosRequestConfig
) => Promise<PaginatedList<CashManagementProviderCustomerConfig>>;

export const getCashManagementProviderCustomerConfigs: GetCashManagementProviderCustomerConfigs = async (
  customerId,
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/customers/${customerId}/cash-management-provider/config`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
};
export const getCashManagementProviderCustomerConfig: GetCashManagementProviderCustomerConfig = async (
  configId,
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/cash-management-provider/config/${configId}`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export const postCashManagementProviderCustomerConfig: PostCashManagementProviderCustomerConfig = async (
  customerId,
  config,
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "POST",
      url: `/customers/${customerId}/cash-management-provider/config`,
      data: {
        ...config,
        cashManagementProvider: config.cashManagementProvider.id,
      },
    });
    const { data = {} } = response;
    return await getCashManagementProviderCustomerConfig(data.id, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export const putCashManagementProviderCustomerConfig: PutCashManagementProviderCustomerConfig = async (
  configId,
  config,
  options
) => {
  try {
    await axios({
      ...options,
      method: "PUT",
      url: `/cash-management-provider/config/${configId}`,
      data: {
        ...config,
        cashManagementProvider: config.cashManagementProvider.id,
      },
    });
    return await getCashManagementProviderCustomerConfig(configId, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
};
